export default __webpack_public_path__ + "static/media/squares800.77a23d16.jpg";